export default __webpack_public_path__ + "static/media/Hemanth.83668a9f.png";